/**
 * Pub/sub for the small "Push notifications blocked" modal. Same pattern
 * as the other modal services (expiredLinkModalService, pushPermissionModalService).
 *
 * Shown only when a user taps the Push toggle ON in Settings while the OS
 * permission is `denied`. There's no programmatic recovery from the denied
 * state — the user has to manually re-enable in OS / browser settings —
 * so this modal just surfaces the platform-specific instructions with a
 * Close button. No retry button (would 404 against the browser), no
 * dismiss-on-backdrop subtlety needed.
 */
type State = {
  isOpen: boolean;
};

type Listener = (state: State) => void;

let state: State = { isOpen: false };
const listeners: Set<Listener> = new Set();

function notify() {
  listeners.forEach((l) => l(state));
}

export function openPushBlockedModal() {
  state = { isOpen: true };
  notify();
}

export function closePushBlockedModal() {
  state = { isOpen: false };
  notify();
}

export function subscribeToPushBlockedModal(listener: Listener): () => void {
  listeners.add(listener);
  listener(state);
  return () => listeners.delete(listener);
}
